const images = {
	logo: require('./images/logo.png'),
	placeholder: require('./images/placeholder.png'),
	qrcode: require('./images/qr-code.png'),
	logoWithText: require('./images/logo_with_text.svg')
};

export default images;
